import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';

export const adminViewWalkthrough: WalkthroughEvent = {
    key: 'admin-view-walkthrough',
    showAt: 'start',
    steps: [
        // {
        //     id: '0',
        //     element: { selector: '[data-tour=dashboard]' },
        //     position: 'right',
        //     text: t('app.platformTour.dashboard'),
        // },
        // {
        //     id: '1',
        //     element: { selector: '[data-tour=progress-report]' },
        //     text: t('app.platformTour.progressReport'),
        // },
        // {
        //     id: '2',
        //     element: { selector: '[data-tour=profile-settings]' },
        //     text: t('app.platformTour.profileSettings'),
        // },
        // {
        //     id: '3',
        //     element: { selector: '[data-tour=courses]' },
        //     text: t('app.platformTour.courses'),
        // },
    ],
};

export default adminViewWalkthrough;
